export const NSIPS_CONSTANTS = {
  MIN_SEARCH_LENGTH: 2,
  SEARCH_DEBOUNCE_MS: 300,
  GENDER: {
    MALE: '1',
    FEMALE: '2',
  },
  DATE_FORMAT: 'YYYYMMDD',
  DATE_FORMAT_REGEX: /^\d{8}$/,
  DEFAULT_FILENAME: 'nsips_export.txt',
  KANA_REGEX: /[^ァ-ヶｦ-ﾟーｰ\s]/g, // 全角カタカナと半角カタカナ、長音符、スペースのみ許可
  DIGIT_ONLY_REGEX: /\D/g,
} as const

export const NSIPS_LABELS = {
  PATIENT_CODE: '患者コード',
  PATIENT_KANA_NAME: '患者カナ氏名',
  PATIENT_KANJI_NAME: '患者漢字氏名',
  GENDER: '性別',
  BIRTH_DATE: '生年月日',
  USAGE: '用法',
  DAYS: '日数',
  DRUG_NAME: '薬品名',
  QUANTITY: '数量',
  UNIT: '単位',
} as const

export const NSIPS_ERRORS = {
  PATIENT_CODE_REQUIRED: '患者コードは必須です',
  PATIENT_KANA_NAME_REQUIRED: '患者カナ氏名は必須です',
  PATIENT_KANA_NAME_FORMAT: 'カタカナで入力してください',
  PATIENT_KANJI_NAME_REQUIRED: '患者漢字氏名は必須です',
  GENDER_REQUIRED: '性別は必須です',
  BIRTH_DATE_REQUIRED: '生年月日は必須です',
  BIRTH_DATE_FORMAT: 'YYYYMMDD形式で入力してください',
  USAGE_REQUIRED: '用法は必須です',
  DAYS_REQUIRED: '日数は必須です',
  DRUG_NAME_REQUIRED: '薬品名は必須です',
  QUANTITY_REQUIRED: '数量は必須です',
  UNIT_REQUIRED: '単位は必須です',
  EXPORT_FAILED: 'エクスポートに失敗しました',
  EXPORT_RETRY: 'エクスポートに失敗しました。時間をおいて再度お試しください',
  AUTH_ERROR: '認証エラー: ログインしてください',
  INPUT_ERROR: '入力エラー',
  DOWNLOAD_FAILED: 'ダウンロードの準備に失敗しました',
  VALIDATION_ERROR: '入力エラーがあります。確認してください。',
} as const
